// extracted by mini-css-extract-plugin
module.exports = {"icon":"KtOrderCheckoutButton_icon__WT4SD"};